import { Tabs } from '@factorialco/factorial-one-react/dist/experimental'

import { useMemo } from 'modules/core/hooks/useMemo'

import {
  CategoryType,
  DEFAULT_CATEGORIES,
  getCategoryTranslation,
} from 'modules/job_catalog/lib/nodesUtils'

interface Props {
  setActiveTab: (tab: CategoryType) => void
  activeTab: CategoryType
  nodeType: string
}

const CategoriesTabs = ({ setActiveTab, activeTab, nodeType }: Props) => {
  const visibleTabs = useMemo(() => {
    const always = [DEFAULT_CATEGORIES.COMPETENCIES]
    const showOverview = nodeType !== 'level'

    return showOverview ? [DEFAULT_CATEGORIES.OVERVIEW, ...always] : always
  }, [nodeType])

  const handleTabChange = (tabId: string) => {
    const newTab = visibleTabs.find((tab) => tab === tabId)
    if (newTab) setActiveTab(newTab)
  }

  return (
    <Tabs
      tabs={visibleTabs.map((value) => ({
        label: getCategoryTranslation(value, nodeType),
        id: value,
      }))}
      setActiveTabId={handleTabChange}
      activeTabId={activeTab || DEFAULT_CATEGORIES.OVERVIEW}
    />
  )
}

export default CategoriesTabs
